import { ResponseModel } from "../model/response/ResponseModel";
import { OnlineMenuModel } from "../model/response/OnlineMenuResponseModel";
import api from "../Api";
import { ApiPath } from "../ApiPath";
import { OrderPostModel } from "../model/request/OrderModel";

const OrderService = () => {
  const subDomain = window.location.href.includes("localhost:")
    ? "demo"
    : window.location.href.replaceAll("https://", "").replaceAll("http://", "").split(".")[0];

  const subDomainParams = new URLSearchParams({
    title: subDomain
  });

  function sendOrder(body: OrderPostModel) {
    const err = { error: true } as ResponseModel<OnlineMenuModel>;
    return api()
      .post<ResponseModel<any>>(`${ApiPath.sendOrder}?${subDomainParams}`, {requestModel: body})
      .then((value) => {
        if (value.data.statusCode === 1000) {
          return value.data;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }

  return {
    sendOrder
  };
};
export default OrderService;
